import { toastSuccess, toastError } from './toast/toast.js';

const copyToClipboard = (text, successMessage, errorMessage) => navigator.clipboard.writeText(text).then(() => {
    toastSuccess(successMessage || 'Copied to clipboard');
}).catch((_err) => {
    toastError(errorMessage || 'Failed to copy to clipboard');
});

export { copyToClipboard };
